module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_12.d050e1a2.jpg";